import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthorService } from '@services/author/author.service';
import { NavigationExtras, Router } from '@angular/router';
import { QueueService } from '@services/queue/queue.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthorAPIResponse } from 'src/app/shared/interface/author.interface';
import { TrackingSegmentService } from '@services/segment/tracking-segment.service';
import { AnalysisStatus } from 'src/app/shared/interface/analysis';

@Component({
  selector: 'analysis-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit{
  @Input() active: boolean;
  @Output() showMenu: EventEmitter<boolean> = new EventEmitter();

  showAudit: boolean;
  showReport: boolean;

  constructor(
    private authorService: AuthorService,
    private queueService: QueueService,
    private router: Router,
    private permService: NgxPermissionsService,
    private trackingSegment: TrackingSegmentService) {
    }

  ngOnInit(): void {
    this.getInfoAuthor();
  }

  getInfoAuthor() {
    this.authorService.getAuthorInfo().subscribe((author: AuthorAPIResponse) => {
      const payload = {
        user_id: author?.id,
        name: author?.name,
        email: author?.email,
        properties: {}
      }
      localStorage.setItem('analyst_email', author?.email);
      localStorage.setItem('id', author?.id);
      this.trackingSegment.identify(payload);
      this.permService.loadPermissions(author.scopes);
    })
  }

  toggleMenu(): void {
    this.showMenu.emit(false);
  }

  logout() {
    this.authorService.logout();
    this.authorService.redirectLogout();
  }
  
  private getStatusFirstAnalysis(queue: Array<string>): void {
    if (queue?.length) {
      const itemAnalysis = queue.slice(0, 1).toString();
      this.queueService
        .getAnalysisStatus(itemAnalysis)
        .subscribe((response: AnalysisStatus) => {
          if (sessionStorage.getItem('state')) {
            sessionStorage.removeItem('state');
          }
          return this.redirectAnalysis(response)
        });
    }
  }

  private redirectAnalysis(status: AnalysisStatus): void {
    if (status?.ready) {
      const id: NavigationExtras = {
        queryParams: { id: status?.id },
      };
      this.router.navigate(['/analysis'], id);
    }
  }

}
